import { featuredEntry } from "@/mocks/home";

export default function FeaturedEntry() {
  return (
    <section id="entries" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-20 md:px-8 md:py-32">
        <div className="mb-12 flex flex-col gap-4 md:mb-16 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="font-label text-xs tracking-[0.3em] text-primary-500 md:text-sm">
              TODAY&apos;S PICK
            </p>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              今日主推入口
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            综合当前连通性、延迟与稳定性选出的首选线路，适合作为日常访问的第一入口。
          </p>
        </div>

        <article className="grid grid-cols-1 overflow-hidden rounded-lg border border-background-200 bg-background-100 lg:grid-cols-2">
          <div className="relative w-full min-h-[280px] md:min-h-[420px]">
            <img
              src={featuredEntry.image}
              alt="今日主推的黑料地址镜像入口封面"
              title="黑料地址 主推入口 镜像站"
              className="absolute inset-0 h-full w-full object-cover object-top"
            />
            <span className="absolute left-5 top-5 inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 font-label text-xs font-semibold text-primary-700 md:text-sm">
              <i className="ri-star-smile-line"></i>
              {featuredEntry.badge}
            </span>
          </div>

          <div className="flex flex-col justify-center gap-6 p-6 md:p-12">
            <div className="flex flex-wrap items-center gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-900">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-soft-pulse"></span>
                {featuredEntry.status}
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-medium text-secondary-900">
                {featuredEntry.region}
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 font-label text-xs font-medium text-secondary-900">
                延迟 {featuredEntry.latency}
              </span>
            </div>

            <div>
              <h3 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {featuredEntry.title}
              </h3>
              <p className="mt-2 font-label text-sm text-foreground-500">{featuredEntry.host}</p>
            </div>

            <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
              {featuredEntry.desc}
            </p>

            <p className="font-label text-xs text-foreground-500">{featuredEntry.updated}</p>

            <a
              href="#mirrors"
              className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3 font-label text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-foreground-800"
            >
              <i className="ri-arrow-right-up-line text-base"></i>
              {featuredEntry.cta}
            </a>
          </div>
        </article>
      </div>
    </section>
  );
}